export interface DropdownOption<T = string> {
    label: string;
    value: T;
}

// ─── Table defaults ──────────────────────────────────────────────────────────
export const ACCOUNTS_DEFAULT_PAGE_SIZE = 10;
export const ACCOUNTS_DEFAULT_SORT_COLUMN = 'dateCreated';
export const ACCOUNTS_DEFAULT_SORT_TYPE: 'ASC' | 'DESC' = 'ASC';

// ─── Table headers ───────────────────────────────────────────────────────────
export const ACCOUNTS_TABLE_SUB_HEADERS = [
    { label: 'FIRST NAME',      key: 'firstName' },
    { label: 'MIDDLE NAME',     key: 'middleName' },
    { label: 'LAST NAME',       key: 'lastName' },
    { label: 'PHONE NUMBER',    key: 'phoneNumber' },
    { label: 'EMAIL',           key: 'email' },
    { label: 'DATE CREATED',    key: 'dateCreated' },
    { label: 'REFERRER NAME',   key: 'referrerName' },
    { label: 'REFERRAR SOURCE', key: 'referralSource' },
    { label: 'BALANCE',         key: 'balance' },
    { label: 'REWARD',          key: 'rewards' },
    { label: 'STATUS',          key: 'status' },
    { label: 'ACCOUNT TYPE',    key: 'accountType' },
    { label: 'TIER TYPE',       key: 'tierId' },
    { label: 'EMAIL VERIFIED',  key: 'isEmailVerified' },
    { label: 'DIRECT VERIFIED EMAIL BY',   key: 'directVerifiedEmailBy' },
    { label: 'DIRECT VERIFIED EMAIL DATE', key: 'directVerifiedEmailDate' },
    { label: 'ACTION', key: null, sortable: false, centered: true },
];

// ─── Filter dropdown options ─────────────────────────────────────────────────
export const ACCOUNT_TYPE_OPTIONS: DropdownOption[] = [
    { label: 'User',     value: '1' },
    { label: 'Merchant', value: '2' },
];

export const ACCOUNT_STATUS_OPTIONS: DropdownOption[] = [
    { label: 'Active',   value: '0' },
    { label: 'Inactive', value: '1' },
];

export const ACCOUNT_TIER_TYPE_OPTIONS: DropdownOption[] = [
    { label: 'Default',  value: '1' },
    { label: 'BLA',      value: '9' },
    { label: 'MegaOne',  value: '8' },
    { label: 'MegaBiz',  value: '7' },
    { label: 'Platinum', value: '6' },
    { label: 'Internal', value: '5' },
    { label: 'Full',     value: '4' },
    { label: 'N/A',      value: '3' },
];

export const EMAIL_VERIFIED_OPTIONS: DropdownOption<boolean>[] = [
    { label: 'True',  value: true },
    { label: 'False', value: false },
];
